import React, { createContext, useReducer, useEffect, useContext } from 'react';
import axios from 'axios';
import AuthContext from './AuthContext';

const ProjectContext = createContext();

const projectReducer = (state, action) => {
  switch (action.type) {
    case 'PROJECTS_LOADED':
      const userDefaultId = action.userDefaultId;
      const savedPermanentId = localStorage.getItem('permanentProjectId');
      const targetId = userDefaultId || savedPermanentId;
      const foundProject = targetId ? action.payload.find(p => p._id === targetId) : null;
      const active = foundProject || state.activeProject || action.payload[0] || null;
      if (active && active._id && !savedPermanentId) {
        localStorage.setItem('permanentProjectId', active._id);
      }
      return {
        ...state,
        projects: action.payload,
        activeProject: active,
        loading: false
      };
    case 'SET_ACTIVE_PROJECT':
      return {
        ...state,
        activeProject: action.payload
      };
    case 'CLEAR_PROJECTS':
      return {
        ...state,
        projects: [],
        activeProject: null,
        loading: false
      };
    default:
      return state;
  }
};

export const ProjectProvider = ({ children }) => {
  const { isAuthenticated, user, loadUser } = useContext(AuthContext);
  const initialState = {
    projects: [],
    activeProject: null,
    loading: true
  };

  const [state, dispatch] = useReducer(projectReducer, initialState);

  const fetchProjects = async () => {
    try {
      const res = await axios.get('/api/projects');
      dispatch({ 
        type: 'PROJECTS_LOADED', 
        payload: res.data,
        userDefaultId: user ? user.defaultProjectId : null
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isAuthenticated && user) {
      fetchProjects();
    } else if (!isAuthenticated) {
      dispatch({ type: 'CLEAR_PROJECTS' });
    }
  }, [isAuthenticated, user]);

  const setActiveProject = async (project) => {
    if (project && project._id) {
      localStorage.setItem('permanentProjectId', project._id);
      try {
        await axios.put('/api/users/profile', { defaultProjectId: project._id });
        if (loadUser) loadUser();
      } catch (err) {
        console.error('Error saving default project to profile:', err);
      }
    }
    dispatch({ type: 'SET_ACTIVE_PROJECT', payload: project });
  };

  const updateProject = async (projectId, updates) => {
    try {
      const res = await axios.put(`/api/projects/${projectId}`, updates);
      await fetchProjects();
      if (state.activeProject && state.activeProject._id === projectId) {
        dispatch({ type: 'SET_ACTIVE_PROJECT', payload: res.data });
      }
      return true;
    } catch (err) {
      console.error('Error updating project:', err);
      return false;
    }
  };

  return (
    <ProjectContext.Provider value={{ ...state, fetchProjects, setActiveProject, updateProject }}>
      {children}
    </ProjectContext.Provider>
  );
};

export default ProjectContext;
